export const purpleData = {
        title: 'Join our global community',
        text: 'Be part of our growing community of developers and innovators who are helping build the Hash Protocol network.',
        boxes: [
            {
                id : 1,
                title : 'Community Chat',
                text : 'Ask general questions and chat with the worldwide community on Telegram.',
                icon: 'home/purple-box-1.svg',
                button:{
                    title:'Start Chatting',
                    url: 'https://t.me/HashProtocolCommunity'
                }
            },
            {
                id : 2,
                title : 'Twitter',
                text : 'Follow zkhashprotocol to get the latest news and updates from across the ecosystem.',
                icon: 'home/purple-box-2.svg',
                button:{
                    title:'Follow',
                    url: 'https://twitter.com/hashprotocol'
                }
            },
            {
                id : 3,
                title : 'Developer Chat',
                text : 'Have technical questions about Hash Protocol tools? Ask a developer on the Community Discord.',
                icon: 'home/purple-box-3.svg',
                button:{
                    title:'Ask a question',
                    url: 'https://discord.com/invite/'
                }
            },
            {
                id : 4,
                title : 'Github',
                text : 'Are you a developer? Take part in engineering discussions and contribute code on our GitHub.',
                icon: 'home/purple-box-4.svg',
                button:{
                    title:'Start contributing',
                    url: 'https://github.com/hashprotocol'
                }
            }
        ]
    }

